import { useMemo } from "react";
import { useStore } from "@/store/store";
import { Detection } from "@/store/detection-slice";

export const useLatestDetections = () => {
  // Subscribe to just the raw detections array from the store.
  const detections = useStore((state) => state.detections);

  // Memoize the computed latest detections so that the returned array is stable
  // unless the `detections` array changes.
  return useMemo(() => {
    const latestByDrone = new Map<string, Detection>();
    detections.forEach((d) => {
      const existing = latestByDrone.get(d.drone_identifier);
      if (
        !existing ||
        new Date(d.detection_time).getTime() >
          new Date(existing.detection_time).getTime()
      ) {
        latestByDrone.set(d.drone_identifier, d);
      }
    });
    return Array.from(latestByDrone.values());
  }, [detections]);
}; 